import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import {gsap} from "gsap";

export default class Faq extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
    
    let itemList = this.$root.find(".item").toArray();

    itemList.forEach((elem)=>
    {
      let $item = $(elem),
        $answer = $item.find(".answer"),
        isOpen = $item.attr("is-open") === "true";
      
      $item.find(".question").on("click", (event:JQuery.ClickEvent)=>
      {
        event.preventDefault();

        let height = $answer.height();        

        isOpen = !isOpen;
        $item.attr("is-open", isOpen? "true": "false");

        !isOpen?
          gsap.from($answer, {maxHeight: height, duration: .25, clearProps: "all"}):
          gsap.from($answer, {height: height, duration: .25, clearProps: "all"});
      });
    });
    
  }
}